import { useTranslation } from "react-i18next";
import { Progress, Image } from "@nextui-org/react";
import PoweredBy from "./PoweredBy";

function DocUpLoadingPage({ imageSrc, progress }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col p-4 h-full gap-4 justify-between">
      <Progress
        aria-label={t("common.docUpLoadingPage.ariaLabel")}
        size="md"
        isIndeterminate
        color="primary"
        className="max-w-md"
      />
      <div className="flex flex-col gap-4 items-center flex-1 justify-center">
        <Image
          width="90%"
          className="max-w-2xl max-h-[60vh] object-contain"
          alt={t("common.docUpLoadingPage.imageAlt")}
          src={imageSrc}
        />
        <div className="heading text-xl">{t("common.docUpLoadingPage.heading")}</div>
        <div className="desc" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{t("common.docUpLoadingPage.desc")}</div>
      </div>
      <div className="flex flex-col items-center">
        <PoweredBy />
      </div>
    </div>
  );
}

export default DocUpLoadingPage;